import React from 'react';
import KoobTooltip from '@koob/ui/src/components/KoobTooltip';

interface TripVersionCompareButtonProps {
  version: { id: string };
  onClick: (version: any | null) => void;
  active: boolean;
  tip: React.ReactNode;
}

export default function TripVersionCompareButton({
  version,
  onClick,
  active,
  tip,
}: TripVersionCompareButtonProps) {
  return (
    <button
      onClick={() => onClick(!active ? version : null)}
      className={[
        'group border-none transition z-20 bg-blue-100 hover:bg-blue-500',
        active && 'bg-blue-500 text-white',
      ].join(' ')}
      data-testid={`compare-version-${version.id}`}
    >
      <KoobTooltip tip={tip} position="left" disabled={active}>
        <div className="h-10 w-10 flex justify-center items-center">
          <i
            className={[
              'far fa-eye text-lg text-gray-600 transition',
              !active && 'group-hover:text-white',
            ].join(' ')}
          />
        </div>
      </KoobTooltip>
    </button>
  );
}
